import { getSizedImageUrl } from "../../objectFitImages";

export default class VariantWishlist {
    constructor(variant) {
        this.id = variant.id;
        this.quantity = variant.quantity;
        this.productId = variant.product_id;
        this.productHandle = variant.product_handle;
        this.productTitle = variant.product_title;
        this.productType = variant.product_type;
        this.title = variant.title;
        this.image = variant.image;
        this.price = variant.price;
        this.sku = variant.sku;
        this.available = variant.available;
        this.options = variant.options;
        this.availableOptions = variant.available_options;
        this.checked = false;
    }

    isAvailable() {
        return this.available === true;
    }

    hasProductType(type) {
        return this.productType.includes(type);
    }

    getImageUrlBySize(size) {
        return getSizedImageUrl(this.image, size);
    }

    getAvailableValuesForOption(optionKey) {
        let key = Object.keys(this.availableOptions).find((availableOptionKey) => availableOptionKey === optionKey);
        if (key) {
            return this.availableOptions[key];
        }
        return "";
    }

    getOptionValue(key) {
        if (typeof this.options[key] !== "undefined") {
            return this.options[key];
        }
        return "";
    }

    getPriceInPriceFormat() {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            currencySign: "accounting",
        }).format(this.price);
    }

    renderOptions() {
        return Object.entries(this.options)
            .map(([key, value]) => `${key}: ${value}`)
            .join("/");
    }
}
